export default __webpack_public_path__ + "static/media/dropbox.ee52741b.svg";